import React, { useState, useEffect } from "react";
import { Table } from "antd";
import Api from "../../../../../services/ServiceApi";

import ModalSuccess from "../../../../../components/Modal_Success";
import Cookies from "js-cookie";
import moment from "moment";
import { VList } from "virtuallist-antd";

const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];


const JobBookingTable = (bookingData) => {
  const [modalstatus, setmodalstatus] = useState(0);
  function del_booking(data){
    Api.post("deleteBooking", {   
      "bus_booking_id" : data.bus_booking_id
      ,"create_by" : Cookies.get("userId")
    })
      .then((res) => {
        setmodalstatus(true);
        Cookies.set("activeTab", 1 , { expires: 1 })
        // window.location.reload(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const columns = [
    // Bus
    {
      title: " " ,
      width: 70,
      // dataIndex: "booking_code",
      // key: "booking_code",
      render: (record, data) => {
        // console.log('bus data', data)
        //console.log('bus data', data.bus_booking)
        return (
          <a
            href="job_detail_view_only"
            // href="#"
            className="c-blue text-underline"
            target="_blank"
            onClick={() => {
              if (data !== null) {  
                // console.log("bus_booking_id : ",data.bus_booking_id);
                Cookies.set("bus_booking_id", data.bus_booking_id)
                //่booking_id
              }
            }}
          >
            <img src={Api.absoluteUrl("/icon/view.svg")} width="35"/>
          </a>
        );
      },
    },
    {
      title: "Booked ID",
      dataIndex: "booking_code",
      key: "booking_code",
      render: (record, data) => {
        // console.log('bus data', data)
        //console.log('bus data', data.bus_booking)
        return (
          <a
            href="job_detail"
            // href="#"
            className="c-blue text-underline"
            onClick={() => {
              if (data !== null) {  
                // console.log("bus_booking_id : ",data.bus_booking_id);
                Cookies.set("bus_booking_id", data.bus_booking_id)
                //่booking_id
              }
            }}
          >
            {record}
          </a>
        );
      },
      sorter: (a, b) => {
            if( (a.booking_code !== undefined && b.booking_code !== undefined) &&  (a.booking_code !== null && b.booking_code !== null) ){ 
                    return   a.booking_code.localeCompare(b.booking_code)
            }
         }
    },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      sorter: (a, b) => {
        if( (a.customer !== undefined && b.customer !== undefined) &&  (a.customer !== null && b.customer !== null) ){ 
                return   a.customer.localeCompare(b.customer)
        }
     }
    },

    {
      title: "Project",
      dataIndex: "project_name",
      key: "project_name",
      sorter: (a, b) => {
        if( (a.project_name !== undefined && b.project_name !== undefined) &&  (a.project_name !== null && b.project_name !== null) ){ 
                return   a.project_name.localeCompare(b.project_name)
        }
     }
 
    },
    {
      title: "Total Bus",
      dataIndex: "total_bus",
      key: "total_bus",
      //render: (totalBus) => <span>{totalBus} Bus</span>
      render: (totalBus) => {
        return <span>{totalBus} Bus</span>
      },
      sorter: (a, b) => {
        if( (a.total_bus !== undefined && b.total_bus !== undefined) &&  (a.total_bus !== null && b.total_bus !== null) ){ 
                return   a.total_bus - b.total_bus
        }
     }
    },
    {
      title: "Total Bus Finished",
      dataIndex: "total_bus_finish",
      key: "total_bus_finish",
      //render: (totalBus) => <span>{totalBus} Bus</span>
      render: (totalBus) => {
        return <span>{totalBus} Bus</span>
      },
      sorter: (a, b) => {
        if( (a.total_bus_finish !== undefined && b.total_bus_finish !== undefined) &&  (a.total_bus_finish !== null && b.total_bus_finish !== null) ){ 
                return   a.total_bus_finish - b.total_bus_finish
        }
     }
    },
    {
      title: "Total Booking",
      //render: (totalBus) => <span>{totalBus} Bus</span>
      render: (item) => {
        return <span>{item.total_bus + item.total_bus_finish}</span>
      },
      sorter: (a, b) => {
        if( (a.total_bus !== undefined && b.total_bus !== undefined) &&  (a.total_bus !== null && b.total_bus !== null) ){ 
                return   (a.total_bus + a.total_bus_finish)  - (b.total_bus + b.total_bus_finish)
        }
     }
    },
    {
      title: "ฺBooking Internal Start Date",
      // dataIndex: "booking_internal_date",
      key: "booking_internal_date",
      render: (item) => {
        return <span>{dateFormat(item.booking_internal_date)}</span> 

      },
      sorter: (a, b) => {
        if( (a.booking_internal_date !== undefined && b.booking_internal_date !== undefined) &&  (a.booking_internal_date !== null && b.booking_internal_date !== null) ){ 
                return   a.booking_internal_date.localeCompare(b.booking_internal_date)
        }
     }
    },
    {
      title: "ฺBooking Internal End Date",
      // dataIndex: "booking_internal_date_end",
      key: "booking_internal_date_end",
      render: (item) => {
        return <span>{dateFormat(item.booking_internal_date_end)}</span> 
      },
      sorter: (a, b) => {
        if( (a.booking_internal_date_end !== undefined && b.booking_internal_date_end !== undefined) &&  (a.booking_internal_date_end !== null && b.booking_internal_date_end !== null) ){ 
                return   a.booking_internal_date_end.localeCompare(b.booking_internal_date_end)
        }
     }
    },
    {
      title: "Booking External Start Date",
      // dataIndex: "booking_external_date",
      key: "booking_external_date",
      render: (item) => {
        return <span>{dateFormat(item.booking_external_date)}</span>
      },
      sorter: (a, b) => {
        if( (a.booking_external_date !== undefined && b.booking_external_date !== undefined) &&  (a.booking_external_date !== null && b.booking_external_date !== null) ){ 
                return   a.booking_external_date.localeCompare(b.booking_external_date)
        }
     }
    },
    {
      title: "Booking External End Date",
      // dataIndex: "booking_external_date_end",
      key: "booking_external_date_end",
      render: (item) => {
        return <span>{dateFormat(item.booking_external_date_end)}</span>
      },
      sorter: (a, b) => {
        if( (a.booking_external_date_end !== undefined && b.booking_external_date_end !== undefined) &&  (a.booking_external_date_end !== null && b.booking_external_date_end !== null) ){ 
                return   a.booking_external_date_end.localeCompare(b.booking_external_date_end)
        }
     }
    },
    
    {
      title: "Locking",
      dataIndex: "booking_complete_flag",
      key: "booking_complete_flag",
      render: (item) => 
      (item === 0 ? <span> Not Locking </span> :  <span> Locking</span>)
      ,
      sorter: (a, b) => {
        if( (a.booking_complete_flag !== undefined && b.booking_complete_flag !== undefined) &&  (a.booking_complete_flag !== null && b.booking_complete_flag !== null) ){ 
                return   a.booking_complete_flag - b.booking_complete_flag
        }
     }
    },
    
    {
      title: "Action",
      dataIndex: "",
      key: "",
      render: ( data) => {
        return (
           parseInt(localStorage.getItem("permission"))  === 1 ?
          <button onClick={() => {del_booking(data)}}>
            <img src={Api.absoluteUrl("/icon/delete.svg")} />
          </button>
          : null
        );
      },
    },
  ];

  const  dateFormat = (item) => {

    return !item ? "-" : 
          <>
            {moment(item).format(dateFormatList[0]) != "Invalid date"?
                moment(item).format(dateFormatList[0])
            :item}
          </>;
  }


  return(
    <>
   {modalstatus ? (
          <ModalSuccess
              status="Delete Successfully"
              path_location="/MaxiOperation/bus_status_checking"
          />
      ) : null}
     <Table 
        rowKey="asset_id" 
        columns={columns} 
        dataSource={bookingData.bookingData}     
        pagination={false}   
        scroll={{ x: 3000 , y : 500}}
        components={VList ? VList({
          height: 500,
          width: 3000,
          vid: "third"
        }):null}
        /> 
        </>)

};

export default JobBookingTable;
